//Produción 
export const PROCESOS_ACADEMICOS = 34976;
export const PROCESOS_FINANCIEROS = 34977;
export const SERVICIOS = 34978;


// test
// export const PROCESOS_ACADEMICOS = 33345;
// export const PROCESOS_FINANCIEROS = 33346;
// export const SERVICIOS = 33347;

// Local
// export const PROCESOS_ACADEMICOS = 9760;
// export const PROCESOS_FINANCIEROS = 9761;
// export const SERVICIOS = 9762;